// extracted by mini-css-extract-plugin
export default {"description":"CardDecription_description__o0Oro","active":"CardDecription_active__4UGKe","longActive":"CardDecription_longActive__blC6u","btn":"CardDecription_btn__z9woL"};